<div 
  class="so-checkbox-container"
  [ngClass]="containerClass()"
  [style.gap]="gap()">
  
  @if (effectiveLabelPosition() === 'left' && effectiveLabel()) {
    <label 
      [for]="checkId()"
      class="so-checkbox-label"
      [ngStyle]="labelStyle()"
      [class.truncate]="truncateText()"
      [title]="truncateText() ? effectiveLabel() : ''">
      {{ effectiveLabel() }}
    </label>
  }

  <div class="so-checkbox-wrapper">
    <div
      class="so-checkbox"
      [ngClass]="checkboxClass()"
      [style.width]="checkboxSize()"
      [style.height]="checkboxSize()"
      [attr.role]="'checkbox'"
      [attr.aria-checked]="internalIndeterminate() ? 'mixed' : internalValue()"
      [attr.aria-disabled]="effectiveDisabled()"
      [attr.aria-label]="effectiveLabel() || 'checkbox'"
      [attr.tabindex]="effectiveDisabled() ? -1 : 0"
      [attr.title]="effectiveDisabled() && disabledTooltip() ? disabledTooltip() : ''"
      (click)="onCheckboxClick($event)"
      (keydown)="onKeydown($event)">
      
      @if (showCheckIcon()) {
        <svg 
          class="so-checkbox-icon check-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      }

      @if (showIndeterminateIcon()) {
        <svg 
          class="so-checkbox-icon indeterminate-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      }
    </div>
  </div>

  @if (effectiveLabelPosition() === 'right' && effectiveLabel()) {
    <label 
      [for]="checkId()"
      class="so-checkbox-label"
      [ngStyle]="labelStyle()"
      [class.truncate]="truncateText()"
      [title]="truncateText() ? effectiveLabel() : ''">
      {{ effectiveLabel() }}
    </label>
  }
</div>
